import { render, staticRenderFns } from "./receiving.vue?vue&type=template&id=604b61a2&scoped=true&"
import script from "./receiving.vue?vue&type=script&lang=js&"
export * from "./receiving.vue?vue&type=script&lang=js&"
import style0 from "./receiving.vue?vue&type=style&index=0&id=604b61a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604b61a2",
  null
  
)

export default component.exports